import React, { useState, useImperativeHandle, useEffect, forwardRef, useRef, Fragment } from 'react'
import Address from './modals/Address'
import Api from '../../../../_helpers/Api'
import ReactTooltip from 'react-tooltip'

//images
import docIcon from '../../../../assets/img/icons/document.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import loader from '../../../../assets/img/loader.svg'
import uploadImage from '@/assets/img/storage/icons/upload.svg'
import popupHeadImage from '@/assets/img/settings/icons/popup-head.svg'
import MultiSelect from "react-multi-select-component"
import PermissionCheckboxList from '../../../common/PermissionCheckboxList'
import { useAuthDataContext } from '../../../../_providers/Auth'
import { useParams } from 'react-router-dom'
import { trans } from '../../../../_providers/Translation'
import Error from '../../../modals/messages/Error'
import infoIcon from '../../../../assets/img/icons/info-black.png'
import Help from '../../../partials/Help'
import { Checkbox, FormControlLabel, Switch, Tab, Tabs } from '@mui/material'
import PhoneField from '@/components/partials/PhoneField'
import Skeleton from 'react-loading-skeleton'
import BlueSwitch from '@/components/partials/BlueSwitch'

function AddOrEditEmployee(props, ref) {
    const auth = useAuthDataContext()
    const defaultData = {
        active: true,
        selectedPerms: [],
        selectedAppliances: [],
        selectedAreas: []
    }
    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        edit: false,
        editId: null,
        data: defaultData,
        image: null,
        perms: [],
        appliances: [],
        areas: [],
        loading: false,
    })
    const [activeTab, setActiveTab] = useState('info')
    const [validations, setValidations] = useState(null)
    const [loadingData, setLoadingData] = useState(false)

    const maxEmployeesErrorModal = useRef(null)
    const addressModalRef = useRef(null)

    useImperativeHandle(ref, () => ({
        add: () => {
            setPopup(prev => ({
                ...prev,
                edit: false,
                loading: false,
                data: defaultData,
            }))
            handleShow()
        },
        edit: (id) => {
            setPopup(prev => ({
                ...prev,
                edit: Math.random().toString(),
                editId: id,
                loading: false,
                data: defaultData,
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        }
    }))
    console.log(popup.perms)
    // при редакция извлича текущите данни, за да се попълнят полетата
    useEffect(() => {
        if (popup.edit) {
            setLoadingData(true)

            Api.get(`partners/employees/find?id=${popup.editId}`)
                .then(res => {
                    const emp = res.data || {}

                    const perms = emp.perms || []
                    const appliances = emp.appliances || []
                    const areas = emp.areas || emp.addresses || []

                    const selectedPerms = perms.map(m => ({
                        label: (m.translation && m.translation.name) ? m.translation.name : (m.name || ''),
                        value: Number(m.id)
                    }))

                    const selectedAppliances = appliances.map(m => ({
                        label: (m.translation && m.translation.name) ? m.translation.name : (m.name || ''),
                        value: Number(m.id)
                    }))

                    const selectedAreas = areas.map(a => ({
                        label: a.name || a.address || [a.city, a.neighborhood, a.region, a.postcode].filter(Boolean).join(', '),
                        value: Number(a.id)
                    }))

                    const data = {
                        ...emp,
                        selectedPerms,
                        selectedAppliances,
                        selectedAreas
                    }

                    setPopup(prev => ({
                        ...prev,
                        data: data,
                    }))
                }).catch(err => {
                    console.error('employee load error', err)
                })
                .finally(() => {
                    setLoadingData(false)
                })
        }
    }, [popup.edit])

    useEffect(() => {
        if (!auth.partnerId()) return

        const extractArray = res => {
            if (!res) return []
            if (Array.isArray(res.data)) return res.data
            if (Array.isArray(res.data?.items)) return res.data.items
            if (Array.isArray(res.data?.data)) return res.data.data
            return []
        }

        Api.get('partners/employees/permissions?partner_id=' + auth.partnerId())
            .then(res => {
                const data = res.data.map(m => {
                    const children = (m.children || []).map(c => {
                        return { label: c.translation ? c.translation.name : c.name, value: c.id, children: [] }
                    })

                    return { label: m.translation ? m.translation.name : m.name, value: m.id, children }
                })
                setPopup(prev => ({ ...prev, perms: data }))
            }).catch(err => console.error('permissions load error', err))

        Api.get('addresses/all')
            .then(res => {
                const src = extractArray(res)
                const data = src.map(m => ({ label: m.name, value: m.id }))
                setPopup(prev => ({ ...prev, areas: data }))
            }).catch(err => console.error('addresses load error', err))

        Api.get('partners/categories/all?partner_id=' + auth.partnerId())
            .then(res => {
                const src = extractArray(res)
                const data = src.map(m => ({ label: m.name, value: m.id }))
                setPopup(prev => ({ ...prev, appliances: data }))
            }).catch(err => console.error('categories load error', err))
    }, [auth.partnerId()])

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        if (e) {
            e.preventDefault()
        }

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false,
                image: null,
            }))

            setActiveTab('info')
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url

        if (popup.edit) {
            url = 'partners/employees/edit'
        } else {
            url = 'partners/employees/add'
        }

        let data = new FormData(e.target)

        if (popup.image && popup.image.length > 0 && popup.image[0].t) {
            data.append('image', popup.image[0].t)
        }

        data.append('partner_id', props.partnerId)

        // при редакция - добавяме ID
        if (popup.edit) {
            data.append('id', popup.editId)
        }

        Api.post(url, data)
            .then(res => {
                if (popup.edit) {
                    props.handleUpdate(res.data)
                } else {
                    props.handleCreate(res.data)
                }
                handleHide(e)
                auth.refresh()
                document.getElementById('employee-form').reset()
            }).catch(error => {
                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))
                let _err = error.response
                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {
                        if (input === 'max_employees_reached') {
                            handleHide()
                            let modal = maxEmployeesErrorModal.current
                            modal.open()
                            modal.onClose(() => {
                                handleShow()
                            })
                        }
                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }
            })
    }

    const handleAttachImage = (e) => {
        let attachments = Array.from(e.target.files)
        attachments.map((t, i) => {
            let tmppath = URL.createObjectURL(e.target.files[i])
            attachments[i] = { t, tmppath }
        })
        setPopup(prev => ({
            ...prev,
            image: attachments
        }))
    }

    const handleOpenImage = (e) => {
        e.preventDefault()
        let input = document.getElementById('employee-image')
        input.click()
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    const handleDateChange = e => {
        let name = e.target.name + '_ymd'
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    const handleActiveChange = e => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                active: !prev.data.active
            }
        }))
    }

    const handlePermChange = data => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                selectedPerms: data
            }
        }))
    }

    const handleAppliancesChange = data => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                selectedAppliances: data
            }
        }))
    }

    const handleChangeAddress = (name, lat, lon) => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                address: name,
                home_lat: lat ? Number(lat) : null,
                home_lon: lon ? Number(lon) : null,
            }
        }))
    }

    const handleAreasChange = data => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                selectedAreas: data
            }
        }))
    }

    const getRole = () => {

        let role = props.roles.filter(r => Number(r.id) === Number(popup.data.role_id))[0]

        if (role) {
            return role.name
        }

        return null
    }

    function createMarkup(text) {
        return { __html: text }
    }

    function isTechnician() {
        if (Number(popup.data.role_id) === 3) {
            return true
        }

        return false
    }

    return (
        <>
            <Error
                ref={maxEmployeesErrorModal}
                mainMessage={trans('messages.maxEmployeesReached')}
            />



            <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
                <form id="employee-form" className={`${popup.modal ? 'show' : ''} popup-primary large`} onSubmit={handleSave}>
                    <div className='head-new'>
                        <img src={popupHeadImage} alt="popup head" />
                        <div className='texts'>
                            <h2>
                                {popup.edit ? trans('headings.editEmployee') : trans('headings.addEmployee')}
                            </h2>
                            <p>{trans('subheadings.editEmployee')}</p>
                        </div>
                        <span className='close' onClick={handleHide}>

                        </span>
                    </div>
                    {loadingData ?
                        <Skeleton height={45} count={5} />
                        :
                        <>
                            <Tabs
                                value={activeTab}
                                onChange={(e, newValue) => setActiveTab(newValue)}
                                variant="scrollable"
                                scrollButtons="auto"
                                indicatorColor="primary"
                                textColor="primary"
                                aria-label="scrollable force tabs example"
                            >

                                <Tab value="info" label={trans('labels.employeeBasicInfo')} />
                                <Tab value="qual" label={trans('labels.employeeQualifications')} />
                                <Tab value="access" label={trans('labels.employeeAccess')} />
                            </Tabs>

                            <div style={{ display: activeTab === 'info' ? 'block' : 'none' }}>
                                <div className='row'>
                                    <div className='col'>
                                        <div className="row">
                                            <div className="col">
                                                <label htmlFor="name">{trans('labels.name')}</label>
                                                <input id="name" type="text" name="name" value={popup.data && popup.data.name ? popup.data.name : ''} className={validations && validations.name ? 'validate' : ''} onChange={handleInputChange} />
                                            </div>
                                            <div className="col">
                                                <label htmlFor="lastname">{trans('labels.lastname')}</label>
                                                <input id="lastname" type="text" name="lastname" value={popup.data && popup.data.lastname ? popup.data.lastname : ''} className={validations && validations.lastname ? 'validate' : ''} onChange={handleInputChange} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <label htmlFor="role">{trans('labels.role')}</label>
                                                <select id="role" name="role_id" className={validations && validations.role_id ? 'validate' : ''} value={popup.data && popup.data.role_id ? popup.data.role_id : ''} onChange={handleInputChange}>
                                                    {props.roles.map(r =>
                                                        <option key={'r-' + r.id} value={r.id}>{r.translation.name}</option>
                                                    )}
                                                </select>
                                            </div>
                                            <div className='col'>
                                                <div className="row">
                                                    <div className="col">
                                                        <label htmlFor="work_time_from">{trans('labels.workingHours')}</label>
                                                        <div
                                                            className='row'
                                                            style={{
                                                                gap: "5px",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            <input id="work_time_from" type="time" name="work_time_from" value={popup.data && popup.data.work_time_from ? popup.data.work_time_from : ''} className={validations && validations.work_time_from ? 'validate' : ''} onChange={handleInputChange} />
                                                            -
                                                            <input id="work_time_to" type="time" name="work_time_to" value={popup.data && popup.data.work_time_to ? popup.data.work_time_to : ''} className={validations && validations.work_time_to ? 'validate' : ''} onChange={handleInputChange} />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <label htmlFor="phone">{trans('labels.phone')}</label>
                                                {/* <div style={{ display: 'flex' }}>
                                    <div style={{ background: '#f2f2f2', height: '100%', display: 'flex', alignItems: 'center', fontSize: '12px', padding: '0 5px', borderTopLeftRadius: '3px', borderBottomLeftRadius: '3px' }}>{auth.phoneCode()}</div>
                                    <input value={popup.data && popup.data.phone ? popup.data.phone : ''} type="text" className={validations && validations.phone ? 'validate' : ''} name="phone" onChange={handleInputChange} />
                                </div> */}

                                                <PhoneField
                                                    codeValue={popup.data?.phone_country_code || '+359'}
                                                    numberValue={popup.data && popup.data.phone ? popup.data.phone : ''}
                                                    codeName="phone_country_code"
                                                    numberName="phone"
                                                    validate={validations && validations.phone}
                                                    onCodeChange={e => {
                                                        setPopup(prev => ({
                                                            ...prev,
                                                            data: {
                                                                ...prev.data,
                                                                'phone_country_code': e.target.value
                                                            }
                                                        }))
                                                    }}
                                                    onNumberChange={e => {
                                                        setPopup(prev => ({
                                                            ...prev,
                                                            data: {
                                                                ...prev.data,
                                                                'phone': e.target.value
                                                            }
                                                        }))

                                                    }}
                                                    placeholder={trans('labels.phone')}
                                                />
                                            </div>
                                            <div className="col">
                                                <label htmlFor="email">{trans('labels.email')}</label>
                                                <input id="email" type="text" name="email" value={popup.data && popup.data.email ? popup.data.email : ''} className={validations && validations.email ? 'validate' : ''} onChange={handleInputChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className='col'
                                        style={{
                                            width: "180px",
                                            flexShrink: 0
                                        }}
                                    >
                                        <div className='upload-logo'>
                                            {(popup.image && popup.image.length > 0) ? (
                                                popup.image.map((a, i) => (
                                                    <Fragment key={i}>
                                                        {
                                                            a.tmppath && (
                                                                <img
                                                                    src={a.tmppath}
                                                                    className='uploaded-image'
                                                                    alt="image preview"
                                                                />
                                                            )
                                                        }
                                                    </Fragment>
                                                ))
                                            ) : popup.data?.avatar && typeof popup.data.avatar === 'string' ? (
                                                <img
                                                    src={popup.data.avatar}
                                                    className='uploaded-image'
                                                    style={{ maxHeight: '150px' }}
                                                    alt="employee image"
                                                />
                                            ) : <div className='initial-look'>
                                                <img src={uploadImage} alt="upload" />
                                                <b>
                                                    {trans('labels.picture')}
                                                </b>
                                                <p>
                                                    PNG, JPG, GIF
                                                </p>
                                            </div>}
                                            <div>
                                                <input
                                                    id='employee-image'
                                                    type="file"
                                                    className='webImage'
                                                    onChange={e => handleAttachImage(e)}
                                                    accept="image/*"
                                                    name='image'
                                                    hidden
                                                />
                                                <button className={`button-add button-small ${popup.image && popup.image.length > 0 || popup.data?.avatar ? '' : 'no-logo'}`} onClick={handleOpenImage}>
                                                    {trans('buttons.attachNewLogo')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    {isTechnician() ?
                                        <div className="col">
                                            <label htmlFor="max_reservations">{trans('labels.maxReservations')}</label>
                                            <input id="max_reservations" type="number" min="0" step="1" name="max_reservations" value={popup.data && popup.data.max_reservations ? popup.data.max_reservations : ''} className={validations && validations.max_reservations ? 'validate' : ''} onChange={handleInputChange} />
                                        </div>
                                        :
                                        <>
                                        </>
                                    }

                                    <div className="col">
                                        <label htmlFor="voicecall_phone">{trans('labels.voiceCallPhone')}</label>
                                        {/* <input id="voicecall_phone" type="text" name="voicecall_phone" value={popup.data && popup.data.voicecall_phone ? popup.data.voicecall_phone : ''} className={validations && validations.voicecall_phone ? 'validate' : ''} onChange={handleInputChange} /> */}

                                        <PhoneField
                                            codeValue={popup.data?.phone_country_code || '+359'}
                                            numberValue={popup.data && popup.data.voicecall_phone ? popup.data.voicecall_phone : ''}
                                            codeName="voicecall_phone_country_code"
                                            numberName="voicecall_phone"
                                            validate={validations && validations.voicecall_phone}
                                            onCodeChange={e => {
                                                setPopup(prev => ({
                                                    ...prev,
                                                    data: {
                                                        ...prev.data,
                                                        'voicecall_phone_country_code': e.target.value
                                                    }
                                                }))
                                            }}
                                            onNumberChange={e => {
                                                setPopup(prev => ({
                                                    ...prev,
                                                    data: {
                                                        ...prev.data,
                                                        'voicecall_phone': e.target.value
                                                    }
                                                }))

                                            }}
                                            placeholder={trans('labels.voiceCallPhone')}
                                        />
                                    </div>
                                    <div
                                        className="col"
                                        style={{
                                            width: "180px",
                                            flexShrink: 0
                                        }}
                                    >
                                        <label htmlFor="leaving_date">{trans('labels.leaveDate')}</label>
                                        <input id="leaving_date" type="date" name="leaving_date" value={popup.data && popup.data.leaving_date_ymd ? popup.data.leaving_date_ymd : ''} className={validations && validations.leaving_date ? 'validate' : ''} onChange={handleDateChange} />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col">
                                        <label htmlFor="address">{trans('labels.address')}</label>
                                        <input
                                            id="address"
                                            type="text"
                                            name="address"
                                            value={popup.data && popup.data.address ? popup.data.address : ''}
                                            className={validations && validations.address ? 'validate' : ''}
                                            onClick={() => addressModalRef.current.open()}
                                            readOnly
                                        />
                                        <input type="hidden" name="home_lat" value={popup.data && popup.data.home_lat ? popup.data.home_lat : ''} />
                                        <input type="hidden" name="home_lon" value={popup.data && popup.data.home_lon ? popup.data.home_lon : ''} />
                                    </div>
                                </div>
                                {isTechnician() ?
                                    <div
                                        className='row'
                                        style={{
                                            marginBottom: "10px"
                                        }}
                                    >
                                        <div className="col">
                                            <div
                                                className='row'
                                                style={{
                                                    alignItems: "center"
                                                }}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <BlueSwitch
                                                            name="allow_auto_gps_changes"
                                                            value={popup.data?.allow_auto_gps_changes !== null ? Number(popup.data?.allow_auto_gps_changes) : 1}
                                                        />
                                                    }
                                                    value={popup.data?.allow_auto_gps_changes !== null ? Number(popup.data?.allow_auto_gps_changes) : 1}
                                                    className={validations && validations.max_reservations ? 'validate' : ''}
                                                    onChange={handleInputChange}
                                                    label={trans('labels.allowAutoGPS')}
                                                />
                                                <Help position="right-center" style={{ marginLeft: '-5px' }}>
                                                    <div dangerouslySetInnerHTML={createMarkup(trans('random.allowAutoGPS'))} />
                                                </Help>
                                            </div>

                                        </div>
                                    </div>
                                    :
                                    <>
                                    </>
                                }

                                <div className="row">
                                    <div className="col">
                                        <FormControlLabel
                                            control={
                                                <BlueSwitch
                                                    name="active"
                                                    value={popup.data ? popup.data.active ? 1 : 0 : 1}
                                                />
                                            }
                                            checked={popup.data ? popup.data.active ? true : false : true} className={validations && validations.active ? 'validate' : ''}
                                            onChange={handleActiveChange}
                                            label={trans('labels.active')}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: activeTab === 'qual' ? 'block' : 'none' }}>
                                {getRole() === 'technician' ? (
                                    <>
                                        <div className="row">
                                            <div className="col">
                                                <label>{trans('labels.employeeAppliances')}</label>
                                                <div className="checkbox-list" style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
                                                    {popup.appliances.map(appliance => (
                                                        <FormControlLabel
                                                            key={'appliance-' + appliance.value}
                                                            control={
                                                                <Checkbox
                                                                    name="appliances[]"
                                                                    value={appliance.value}
                                                                    checked={popup.data.selectedAppliances.some(s => s.value === appliance.value)}
                                                                    onChange={(e) => {
                                                                        const isChecked = e.target.checked
                                                                        if (isChecked) {
                                                                            handleAppliancesChange([...popup.data.selectedAppliances, appliance])
                                                                        } else {
                                                                            handleAppliancesChange(popup.data.selectedAppliances.filter(s => s.value !== appliance.value))
                                                                        }
                                                                    }}
                                                                    size='small'
                                                                />
                                                            }
                                                            label={appliance.label}
                                                            sx={{
                                                                margin: "-7px 0"
                                                            }}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="row">
                                            <div className="col">
                                                <label>{trans('labels.areas')}</label>
                                                <div className="checkbox-list" style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
                                                    {popup.areas.map(area => (
                                                        <FormControlLabel
                                                            key={'area-' + area.value}
                                                            control={
                                                                <Checkbox
                                                                    name="address_id[]"
                                                                    value={area.value}
                                                                    checked={popup.data.selectedAreas.some(s => s.value === area.value)}
                                                                    onChange={(e) => {
                                                                        const isChecked = e.target.checked
                                                                        if (isChecked) {
                                                                            handleAreasChange([...popup.data.selectedAreas, area])
                                                                        } else {
                                                                            handleAreasChange(popup.data.selectedAreas.filter(s => s.value !== area.value))
                                                                        }
                                                                    }}
                                                                    size='small'
                                                                />
                                                            }
                                                            label={area.label}
                                                            sx={{
                                                                margin: "-7px 0"
                                                            }}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div style={{ color: '#888', padding: '16px 0', textAlign: 'center' }}>
                                        {trans('messages.qualificationOnlyTechnician') || 'Квалификацията е достъпна само за техници.'}
                                    </div>
                                )}
                            </div>
                            <div style={{ display: activeTab === 'access' ? 'block' : 'none' }}>
                                <div className="row">
                                    <div className="col">
                                        <label>{trans('labels.accessTo')}</label>

                                        <div className="checkbox-list" style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
                                            <PermissionCheckboxList perms={popup.perms} selectedPerms={popup.data.selectedPerms} onChange={handlePermChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    <div className="footer align-right">
                        {popup.loading ?
                            <img src={loader} alt="loading" />
                            :
                            <>
                                <button className="button" onClick={handleHide}>
                                    {trans('buttons.cancel')}
                                </button>
                                <button className="button button-primary" type="submit">
                                    {trans('buttons.save')}
                                </button>
                            </>
                        }
                    </div>
                </form>
            </div>

            <Address
                ref={addressModalRef}
                selected={popup.data && popup.data.address ? popup.data.address : ''}
                params={{
                    lat: popup.data && popup.data.home_lat ? popup.data.home_lat : null,
                    lon: popup.data && popup.data.home_lon ? popup.data.home_lon : null,
                }}
                onSave={handleChangeAddress}
            />
        </>
    )
}

export default forwardRef(AddOrEditEmployee)